//https://docs.payload.com/apis/payments/test-bank-accounts/
export const payloadErrorCodes = {
  'general_reject': 'The payment was rejected.',
  'duplicate_attempt': 'This transaction appears to be a duplicate attempt and has been prevented.',
  'exceeded_limit': 'The amount of the transaction exceeds the allowed limit for this account.',
  'general_decline': 'The bank account has been declined, contact the bank for more information.',
  'insufficient_bal': 'The bank account does not have a sufficient balance to complete the payment.',
  'payment_stopped': 'This payment was stopped.',
  'invalid_account_number': 'The account number is invalid.',
  'not_supported': 'The bank is not supported.',
  'suspicious_activity': 'This payment could not be completed.',
  'too_many_attempts': 'Too many payment attempts have been made, please try again later.',
}

// Payload.Form puts the status code under details, while payload-react events have it at the top level
export function getPayloadErrorMessage(error: any): string | undefined {
  const statusCode = error?.details?.status_code ?? error?.status_code
  return statusCode ? payloadErrorCodes[statusCode as keyof typeof payloadErrorCodes] : undefined
}
